import http from "@/utils/http";
import { URLs } from "./urls";

export const sendWaitingList = async (data: any) => {
  const response = await http.post(URLs.waitingList, data);
  return response.data;
};
